import React, { useState, useEffect } from "react";
import "./AddArticle.css";
import Widgets from "../../../widgets";
import strings from "../../../utils/strings";
import { useTranslation } from "react-i18next";
import DatePicker from "react-multi-date-picker";
import Icons from "../../../Assets/Icons";
import { parse, format, isValid } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import { uploadMedia } from "../../../modules/patientProfile/patientProfileThunk";
import { resetUploadMedia } from "../../../modules/patientProfile/patientProfileSlice";
import { createArticle } from "../../../modules/article/ArticleThunk";
import { resetCreateArt } from "../../../modules/article/ArticleSlice";
import ToastPopup from "../../../widgets/Toast/toastPopup";
import useValidation from "../../../utils/validators";

const AddArticle = ({ setSelectedView }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { validateAddArticle } = useValidation();
  const breadcrumbs = ["healthArt", "artDetails"];
  const paths = [{ onClick: () => setSelectedView("artList") }, strings.navigation.healthArticle];
  const [articleImg, setArticleImg] = useState("");
  const [rawDate, setRawDate] = useState(new Date().toISOString());
  const [currentIndex, setCurrentIndex] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const weekDays = ["S", "M", "T", "W", "T", "F", "S"];
  const [action, setAction] = useState("");
  // const selectedLanguage = useSelector((state) => state.language.language);
  const listType = [
    { value: "description", label: t("description") },
    { value: "unorderedListItem", label: t("unorderedListItem") },
  ];
  const [sections, setSections] = useState([{ contentType: listType[0], content: "", contentVi: "", title: "", titleVi: "", description: "", descriptionVi: "" }]);
  const [formData, setFormData] = useState({
    title: "",
    titleVI: "",
    content: "",
    contentVI: "",
    category: "",
    categoryVI: "",
    authorName: "",
    websiteName: "",
    readingTime: "",
    referenceEn: "",
    referenceVi: "",
  });
  const [selectedLang, setSelectedLang] = useState({ value: "EN", label: t("English") });
  const options = [
    { value: "VI", label: t("Vietnamese") },
    { value: "EN", label: t("English") },
  ];

  const handleNameChange = (e) => {
    const { name, value } = e.target;

    if (name === "readingTime" && !/^\d*$/.test(value)) return;

    setFormData({
      ...formData,
      [name]: value.trimStart(),
    });
  };
  const { uploadMediaSuccess, uploadMediaErr } = useSelector((state) => state.patientProfile);
  const { createArtSuccess, createArtErr } = useSelector((state) => state.article);

  useEffect(() => {
    if (createArtErr) {
      ToastPopup.error(createArtErr);
    }
    if (createArtSuccess && createArtSuccess.status === "success") {
      ToastPopup.success(t("artPublished"));
      setSelectedView("artList");
    }
    dispatch(resetCreateArt());
  }, [createArtSuccess, createArtErr]);

  useEffect(() => {
    if (uploadMediaErr) {
      ToastPopup.error(uploadMediaErr);
    }
    if (uploadMediaSuccess && uploadMediaSuccess.status === "success") {
      const url = uploadMediaSuccess.data.urls[0];
      if (action === "articleImg") {
        setArticleImg(url);
      }
    }
    dispatch(resetUploadMedia());
  }, [uploadMediaErr, uploadMediaSuccess]);

  const hanldeNameChange = (e) => {
    const { name, value } = e.target;

    if (name === "readingTime" && !/^\d*$/.test(value)) return;
    if (name === "websiteName" && /^\d+$/.test(value)) return;
    if (name === "authorName" && !/^[A-Za-z\s]*$/.test(value)) return;

    setFormData({
      ...formData,
      [name]: value.trimStart(),
    });
  };

  const getDateYearsBefore = (years) => {
    const today = new Date();
    return new Date(today.getFullYear() - years, today.getMonth(), today.getDate());
  };
  const getFormattedDate = (date) => {
    let dateObj = new Date(date);
    return format(dateObj, "dd/MM/yyyy");
  };
  const [isOn] = useState(true);

  const handleImageUpload =
    (idType) =>
    ({ files }) => {
      dispatch(uploadMedia({ files }));
      setAction(idType);
    };

  const handleInputChange = (e, index) => {
    let { value } = e.target;
    value = value.replace(/^\s+/, "");
    value = value.replace(/ {3,}/g, "  ");

    const updatedSections = [...sections];
    if (updatedSections[index].contentType.value === "description") {
      updatedSections[index].description = value.replace(/(\n\n)(\n+)/g, "$1");
    } else if (updatedSections[index].contentType.value === "unorderedListItem") {
      updatedSections[index].content = value.split("\n").filter((item) => item.trim() !== "");
    }

    setSections(updatedSections);
  };

  const handleInputChangeVi = (e, index) => {
    let { value } = e.target;
    value = value.replace(/^\s+/, "");
    value = value.replace(/ {3,}/g, "  ");

    const updatedSections = [...sections];
    if (updatedSections[index].contentType.value === "description") {
      updatedSections[index].descriptionVi = value.replace(/(\n\n)(\n+)/g, "$1");
    } else if (updatedSections[index].contentType.value === "unorderedListItem") {
      updatedSections[index].contentVi = value.split("\n").filter((item) => item.trim() !== "");
    }

    setSections(updatedSections);
  };

  const handleBodyTitleChng = (e, index) => {
    const { value } = e.target;
    const updatedSections = [...sections];
    updatedSections[index].title = value.trimStart();
    setSections(updatedSections);
  };
  const handleBodyTitleChngVi = (e, index) => {
    const { value } = e.target;
    const updatedSections = [...sections];
    updatedSections[index].titleVi = value.trimStart();
    setSections(updatedSections);
  };

  const handleKeyDown = (e, index) => {
    if (sections[index].contentType.value === "unorderedListItem" && e.key === "Enter") {
      e.preventDefault();

      const updatedSections = [...sections];
      const textarea = e.target;
      const cursorPosition = textarea.selectionStart;

      let contentArray = updatedSections[index].content;
      if (!Array.isArray(contentArray)) {
        contentArray = contentArray.split("\n"); // Ensure it's an array
      }

      let totalChars = 0;
      let currentLineIndex = 0;

      for (let i = 0; i < contentArray.length; i++) {
        totalChars += contentArray[i].length + 1; // +1 for the newline character
        if (cursorPosition <= totalChars) {
          currentLineIndex = i;
          break;
        }
      }

      const lineOffset = cursorPosition - (totalChars - contentArray[currentLineIndex].length - 1);

      const currentLine = contentArray[currentLineIndex];
      const beforeCursor = currentLine.slice(0, lineOffset);
      const afterCursor = currentLine.slice(lineOffset);

      // Replace current line with the split text
      contentArray.splice(currentLineIndex, 1, beforeCursor, afterCursor);

      updatedSections[index].content = contentArray;
      setSections(updatedSections);

      // Move cursor to the correct position
      setTimeout(() => {
        textarea.selectionStart = textarea.selectionEnd = cursorPosition + 1;
      }, 0);
    }
  };

  const handleKeyDownVi = (e, index) => {
    if (sections[index].contentType.value === "unorderedListItem" && e.key === "Enter") {
      e.preventDefault();

      const updatedSections = [...sections];
      const textarea = e.target;
      const cursorPosition = textarea.selectionStart;

      let contentArray = updatedSections[index].contentVi;
      if (!Array.isArray(contentArray)) {
        contentArray = contentArray.split("\n"); // Ensure it's an array
      }

      let totalChars = 0;
      let currentLineIndex = 0;

      for (let i = 0; i < contentArray.length; i++) {
        totalChars += contentArray[i].length + 1; // +1 for the newline character
        if (cursorPosition <= totalChars) {
          currentLineIndex = i;
          break;
        }
      }

      const lineOffset = cursorPosition - (totalChars - contentArray[currentLineIndex].length - 1);

      const currentLine = contentArray[currentLineIndex];
      const beforeCursor = currentLine.slice(0, lineOffset);
      const afterCursor = currentLine.slice(lineOffset);

      // Replace current line with the split text
      contentArray.splice(currentLineIndex, 1, beforeCursor, afterCursor);

      updatedSections[index].contentVi = contentArray;
      setSections(updatedSections);

      // Move cursor to the correct position
      setTimeout(() => {
        textarea.selectionStart = textarea.selectionEnd = cursorPosition + 1;
      }, 0);
    }
  };

  const handleAddSection = () => {
    const lastSection = sections[sections.length - 1];

    if (lastSection) {
      const isValidDescription = lastSection.contentType.value === "description" && typeof lastSection.description === "string" && lastSection.description.length >= 10;
      const isValidateDescriptionVi = lastSection.contentType.value === "description" && typeof lastSection.descriptionVi === "string" && lastSection.descriptionVi.length >= 10;
      const isValidListItem = lastSection.contentType.value === "unorderedListItem" && Array.isArray(lastSection.content) && lastSection.content.length >= 2;
      const isValidListItemVi = lastSection.contentType.value === "unorderedListItem" && Array.isArray(lastSection.contentVi) && lastSection.contentVi.length >= 2;
      if ((isValidDescription && isValidateDescriptionVi) || (isValidListItem && isValidListItemVi)) {
        setSections([...sections, { contentType: listType[0], content: "", contentVi: "", title: "", titleVi: "", description: "", descriptionVi: "" }]);
      } else {
        if (!isValidDescription && selectedLang.value === "EN" && lastSection.contentType.value === "description") {
          ToastPopup.error(t("previousSectionErr"));
        }
        if (!isValidateDescriptionVi && isValidDescription && lastSection.contentType.value === "description" && selectedLang.value === "EN") {
          ToastPopup.error(t("previousSectionErrVi"));
        }
        if (lastSection.contentType.value === "description" && !isValidateDescriptionVi && selectedLang.value !== "EN") {
          ToastPopup.error(t("previousSectionErr"));
        }
        if (lastSection.contentType.value === "description" && !isValidDescription && isValidateDescriptionVi && selectedLang.value !== "EN") {
          ToastPopup.error(t("previousSectionErrEn"));
        }
        if (lastSection.contentType.value === "unorderedListItem" && !isValidListItem && selectedLang.value === "EN") {
          ToastPopup.error(t("previousListErr"));
        }
        if (lastSection.contentType.value === "unorderedListItem" && isValidListItem && !isValidListItemVi && selectedLang.value === "EN") {
          ToastPopup.error(t("previousListErrVi"));
        }
        if (lastSection.contentType.value === "unorderedListItem" && !isValidListItemVi && selectedLang.value !== "EN") {
          ToastPopup.error(t("previousListErr"));
        }
        if (lastSection.contentType.value === "unorderedListItem" && !isValidListItem && isValidListItemVi && selectedLang.value !== "EN") {
          ToastPopup.error(t("previousListErrEn"));
        }
      }
    } else {
      // If there are no sections, add a new section without validation
      setSections([{ contentType: listType[0], content: "", contentVi: "", title: "", titleVi: "", description: "", descriptionVi: "" }]);
    }
  };
  const handleContentDelete = (index) => {
    setCurrentIndex(index);
    setShowConfirmModal(true);
  };

  // const handleContentDelete = (index) => {
  //   const updatedSections = [...sections];
  //   updatedSections.splice(index, 1);
  //   setSections(updatedSections);
  // };
  const handleConfirmDelete = () => {
    if (currentIndex !== null) {
      const updatedSections = [...sections];
      updatedSections.splice(currentIndex, 1);
      setSections(updatedSections);
      setCurrentIndex(null); // reset the index after deletion
    }
    setShowConfirmModal(false);
  };

  const handleCancelDelete = () => {
    setShowConfirmModal(false);
    setCurrentIndex(null);
  };

  const handleDropdownChange = (value, index) => {
    const updatedSections = [...sections];
    updatedSections[index].contentType = value;
    updatedSections[index].content = [];
    updatedSections[index].contentVi = []; // Clear contentVi as well
    setSections(updatedSections);
    if (value.value === "unorderedListItem") {
      updatedSections[index].description = "";
      updatedSections[index].descriptionVi = "";
    } else if (value.value === "description") {
      updatedSections[index].content = [];
      updatedSections[index].contentVi = [];
    }
  };
  // const handleDropdownChangeVi = (value, index) => {
  //   console.log(value)
  //   const updatedSections = [...sections];
  //   updatedSections[index].contentTypeVi = value;
  //   updatedSections[index].contentType = value; // Update contentType to the same value
  //   updatedSections[index].contentVi = "";
  //   updatedSections[index].content = ""; // Clear content as well
  //   setSections(updatedSections);
  // };
  const handleSave = () => {
    const isValid = validateAddArticle(formData, sections, articleImg, selectedLang.value);
    const totalMinutes = Number(formData.readingTime);
    const normalizeDate = (rawDate) => new Date(rawDate).toISOString();

    // Helper function to remove empty fields from an object
    const removeEmptyFields = (obj) => {
      return Object.fromEntries(Object.entries(obj).filter(([_, value]) => value !== "" && value !== null && value !== undefined && !(Array.isArray(value) && value.length === 0)));
    };

    // Process additional content sections and remove empty fields
    const filteredSections = sections
      .map((section) => {
        if (section.contentType.value === "description" || section.contentType.value === "unorderedListItem") {
          const cleanedSection = removeEmptyFields({
            title: section.title,
            titleVi: section.titleVi,
            description: section.description,
            descriptionVi: section.descriptionVi,
            content: section.content?.length ? section.content : undefined,
            contentVi: section.contentVi?.length ? section.contentVi : undefined,
          });

          // If both content and description are missing, remove this section
          if (!cleanedSection.description && !cleanedSection.content && !cleanedSection.descriptionVi && !cleanedSection.contentVi) {
            return null;
          }

          return cleanedSection;
        }
        return null;
      })
      .filter(Boolean); // Remove null entries (sections without content & description)

    const referenceObject = {
      en: formData.referenceEn?.trim() || "",
      vi: formData.referenceVi?.trim() || "",
    };

    const transformedPayload = removeEmptyFields({
      author: formData.authorName,
      coverImage: articleImg.replace(/ /g, "%20"),
      date: normalizeDate(rawDate),
      websiteName: formData.websiteName,
      reference: referenceObject,
      readingTime: removeEmptyFields({
        hours: Math.floor(totalMinutes / 60),
        minutes: totalMinutes % 60,
      }),
      en: removeEmptyFields({
        title: formData.title,
        category: formData.category,
        content: formData.content,
        additionalContent: filteredSections.length
          ? {
              sections: filteredSections.map((section) =>
                removeEmptyFields({
                  title: section.title,
                  description: section.description,
                  content: section.content,
                }),
              ),
            }
          : undefined,
      }),
      vi: removeEmptyFields({
        title: formData.titleVI,
        category: formData.categoryVI,
        content: formData.contentVI,
        additionalContent: filteredSections.length
          ? {
              sections: filteredSections.map((section) =>
                removeEmptyFields({
                  title: section.titleVi,
                  description: section.descriptionVi,
                  content: section.contentVi,
                }),
              ),
            }
          : undefined,
      }),
    });

    if (isValid) {
      dispatch(createArticle({ transformedPayload }));
    }
  };

  const handleCancel = () => {
    setSelectedView("artList");
  };

  return (
    <div className="department-box article-box">
      <Widgets.BreadCrumb breadcrumbs={breadcrumbs} paths={paths} />
      <div className="dp-heading-flex">
        <div className="department-heading">{selectedLang.value === "EN" ? t("createArt") : t("createArtVi")} </div>
        <Widgets.NewSelectDropdown options={options} big placeholder={t("selGrpName")} onChange={(i) => setSelectedLang(i)} selectedValue={selectedLang} />
      </div>
      <div className="article-head">
        <div className="art-switch">
          <div className="art-form">{t("artFrom")}</div>
        </div>
        <div className="art-form-container">
          <div className="art-title art">
            <label className="art-label">
              {t("title")} {selectedLang.value === "EN" ? <>(En)</> : <>(Vi)</>} <span className="astrik">*</span>
            </label>
            {selectedLang.value === "EN" ? (
              <input value={formData.title} type="text" className="art-input" placeholder={t("enterMainTitle")} name="title" onChange={hanldeNameChange} maxLength={100} />
            ) : (
              <input value={formData.titleVI} type="text" className="art-input" placeholder={t("enterMainTitle") + " (VI)"} name="titleVI" onChange={handleNameChange} maxLength={100} />
            )}
          </div>

          <div className="art-content-category art seprate-textarea">
            <label className="art-label">
              {t("content")} {selectedLang.value === "EN" ? <>(En)</> : <>(Vi)</>} <span className="astrik">*</span>
            </label>
            {selectedLang.value === "EN" ? (
              <textarea placeholder={t("enterContentofArt")} value={formData.content} onChange={hanldeNameChange} name="content" className="art-input text-area-form" maxLength={500} />
            ) : (
              <textarea placeholder={t("enterContentofArt") + " (VI)"} value={formData.contentVI} onChange={handleNameChange} name="contentVI" className="art-input text-area-form" maxLength={500} />
            )}
          </div>

          <div className="art-category art">
            <label className="art-label">
              {t("category")} {selectedLang.value === "EN" ? <>(En)</> : <>(Vi)</>} <span className="astrik">*</span>
            </label>
            {selectedLang.value === "EN" ? (
              <input value={formData.category} type="text" className="art-input" placeholder={t("enterCategory")} name="category" onChange={hanldeNameChange} />
            ) : (
              <input value={formData.categoryVI} type="text" className="art-input" placeholder={t("enterCategory") + " (VI)"} name="categoryVI" onChange={handleNameChange} />
            )}
          </div>
          <div className="art-date art">
            <label className="art-label">
              {t("dateOfPublish")} <span className="astrik">*</span>
            </label>
            <section className="pdl-detail date-pick">
              <input className="art-input" type="text" value={getFormattedDate(rawDate, "dd/MM/yyyy")} />
              <img src={Icons.blackCalender} alt="calender" className="art-date-icon" />
              <section className="custom-date-picker">
                <DatePicker
                  value={rawDate}
                  onChange={(date) => setRawDate(date)}
                  format="DD/MM/YYYY"
                  editable={false}
                  weekDays={weekDays}
                  minDate={getDateYearsBefore(10)}
                  maxDate={getDateYearsBefore(0)}
                />
              </section>
            </section>
          </div>
          <div className="art-author-name art">
            <label className="art-label">
              {t("authorName")} (En) <span className="astrik">*</span>
            </label>
            <input maxLength={100} value={formData.authorName} type="text" className="art-input" placeholder={t("enterAuthor")} name="authorName" onChange={hanldeNameChange} />
          </div>
          <div className="art-reading-time art">
            <label className="art-label">
              {t("readInMin")} <span className="astrik">*</span>
            </label>
            <input value={formData.readingTime} type="text" className="art-input" placeholder={t("egMin")} onChange={hanldeNameChange} name="readingTime" maxLength={2} />
          </div>
          {selectedLang.value === "EN" && (
            <div class="art-reference art">
              <label className="art-label">
                Reference (En) <span className="astrik">*</span>
              </label>
              <input 
                value={formData.referenceEn} 
                type="text" 
                className="art-input" 
                placeholder={t("enterRef")} 
                onChange={hanldeNameChange} 
                name="referenceEn" 
              />
            </div>
          )}
          {selectedLang.value === "VI" && (
            <div class="art-reference art">
              <label className="art-label">
                Tham Khảo (Vi) <span className="astrik">*</span>
              </label>
              <input 
                value={formData.referenceVi} 
                type="text" 
                className="art-input" 
                placeholder={t("enterRef")} 
                onChange={hanldeNameChange} 
                name="referenceVi" 
              />
            </div>
          )}
          <div class="art-website-name art">
            <label className="art-label">
              {t("webName")} (En) <span className="astrik">*</span>
            </label>
            <input value={formData.websiteName} maxLength={100} type="text" className="art-input" placeholder={t("enterWeb")} name="websiteName" onChange={hanldeNameChange} />
          </div>
          <div>
            <label className="art-label-green">
              {t("uploadArtPic")} <span className="astrik">*</span>
            </label>
            <Widgets.SelectCard image={articleImg} idType={"frontPassportId"} front setImage={setArticleImg} onImageUpload={handleImageUpload("articleImg")} />
          </div>
        </div>
      </div>
      <div className="article-body">
        <p className="art-form art-body-title">{t("artBody")}</p>
        <div className="art-form-body">
          {sections.map((section, index) => (
            <div key={index} className="article-contents">
              <label className="art-label">{t("selContentEle")}</label>
              <div className="trash-art">
                <Widgets.NewSelectDropdown
                  options={listType}
                  selectedValue={section.contentType.value === "description" ? { value: "description", label: t("description") } : { value: "unorderedListItem", label: t("unorderedListItem") }}
                  onChange={(value) => {
                    handleDropdownChange(value, index);
                  }}
                  placeholder="Select content type"
                  big
                  noMargin
                />
                <img src={Icons.trashIcon} alt="trash" className="art-trash-icon" onClick={() => handleContentDelete(index)} />
              </div>
              <div class="art-content-category title-body">
                <label className="art-label">
                  {t("heading")} {selectedLang.value === "EN" ? <>(En)</> : <>(Vi)</>}
                  {/* <span className="astrik">*</span> */}
                </label>
                {selectedLang.value === "EN" ? (
                  <input value={section.title} className="art-input" placeholder={t("entrHeading")} name="content" onChange={(e) => handleBodyTitleChng(e, index)} maxLength={500} />
                ) : (
                  <input value={section.titleVi} className="art-input" placeholder={t("entrHeading")} name="content" maxLength={500} onChange={(e) => handleBodyTitleChngVi(e, index)} />
                )}
              </div>
              {section.contentType.value === "description" ? (
                <>
                  {selectedLang.value === "EN" ? (
                    <textarea placeholder={t("enterBriefDes")} value={section.description} onChange={(e) => handleInputChange(e, index)} className="textarea-article" />
                  ) : (
                    <textarea placeholder={t("enterBriefDesVi")} value={section.descriptionVi} onChange={(e) => handleInputChangeVi(e, index)} className="textarea-article" />
                  )}
                </>
              ) : (
                <>
                  {selectedLang.value === "EN" ? (
                    <textarea
                      placeholder={section.contentType.value === "description" ? t("entrDesciption") : t("enterListItems")}
                      value={Array.isArray(section.content) ? section.content.join("\n") : section.content}
                      onChange={(e) => handleInputChange(e, index)}
                      onKeyDown={(e) => handleKeyDown(e, index)}
                      className="textarea-article"
                    />
                  ) : (
                    <textarea
                      placeholder={section.contentType.value === "description" ? t("entrDesciption") : t("enterListItems")}
                      value={Array.isArray(section.contentVi) ? section.contentVi.join("\n") : section.contentVi}
                      onChange={(e) => handleInputChangeVi(e, index)}
                      onKeyDown={(e) => handleKeyDownVi(e, index)}
                      className="textarea-article"
                    />
                  )}
                </>
              )}
              <hr className={`dotted-line-article ${index === sections.length - 1 ? "hide-border" : ""}`} />
            </div>
          ))}
        </div>
        <div className="line-container">
          <hr className="dotted-line" />
          <img src={Icons.plusIcon} alt="+" className="plus-symbol" onClick={handleAddSection} />
        </div>
        <div className="save-speciality dp-price-footer article-save-box">
          <div className="speciality-cancel" onClick={handleCancel}>
            {t("cancel")}
          </div>
          <div className="speciality-save" onClick={handleSave}>
            {t("publish")}
          </div>
        </div>
        <div></div>
      </div>
      <Widgets.ConfirmModal
        showModal={showConfirmModal}
        handleCancel={handleCancelDelete}
        handleConfirm={handleConfirmDelete}
        heading="Delete Content"
        description="Are you sure you want to delete this content?"
      />
    </div>
  );
};

export default AddArticle;
